<template>
        <a      :href="href"
                @click="$emit('click', $event)"
                class="cursor-pointer no-underline hover:no-underline focus:no-underline active:no-underline"
        >
            <slot></slot>
        </a>
</template>

<script>

export default {
    name: "undecorated-link",
    mixins: [],
    emits: ['click'],
    compatConfig: { ATTR_FALSE_VALUE: false },
    components: {},
    props: {
        href: {
            type: [String, Boolean],
            default: null,
        },
    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    },
    methods: {

    },
    computed: {

    },
    watch: {

    },
}

</script>

<style scoped>

</style>